export const ADESOES = () => `/adesoes`;
export const ADESAOSCONSULTAR = () => `/adesoes/consultar`;

/*
 * ⚠️ `/adesoes/edit` e `/adesoes/edit-novo-associado` foram REMOVIDAS na at-56
 * (decisão de Victor, 09/09/2026 — a spec 02 §6 pedia a confirmação formal).
 *
 * Eram cópias antigas da aba de adesões (uma sem busca, outra sem abas), somando
 * 640 linhas, registradas no roteador e com **zero navegadores**: as constantes
 * apareciam só aqui e no `App.tsx`. Não recriar.
 */
